import placeholderImage from 'src/assets/images/placeholder.png';

export const getPlaceHolderImage = () => {
  // In Next.js runtime this import is usually an object with a `.src` field.
  // In Jest it's commonly mocked to a plain string (see `__mocks__/fileMock.ts`).
  if (typeof placeholderImage === 'string') return placeholderImage;
  // @ts-expect-error
  return placeholderImage?.src ?? placeholderImage;
};
